<div *ngIf="displayInline" class="form-group row">
  <label for="{{id}}" class="form-label {{inlineLabelClass}}">{{labelText}}</label>
  <div class="{{inlineFieldClass}}">
    <ng-select [disabled]="disabled" bindValue="{{idKey}}" bindLabel="{{descKey}}" [items]="bindItems" [(ngModel)]="value" required="{{required}}" [placeholder]="placeHolderText"></ng-select>
    <span *ngIf="errorText=='' && required" class="error-label">{{labelText}} is required</span>
  </div>
</div>

<div *ngIf="!displayInline" class="form-group">
  <label for="{{id}}" class="form-label" *ngIf="labelText!=''">{{labelText}}</label>
  <div class="">
    <ng-select [disabled]="disabled" bindValue="{{idKey}}" bindLabel="{{descKey}}" [items]="bindItems" [(ngModel)]="value" required="{{required}}" [placeholder]="placeHolderText"></ng-select>
    <span *ngIf="errorText=='' && required" class="error-label">{{labelText}} is required</span>
  </div>
</div>